<template>
  <div class="contact-page">
    <h1>联系我们</h1>

    <div class="contact-container">
      <section class="contact-info">
        <h2>联系方式</h2>
        <div class="info-item">
          <i class="el-icon-phone"></i>
          <span>电话：+1 647-785-6789</span>
        </div>
        <div class="info-item">
          <i class="el-icon-message"></i>
          <span>邮箱：info@wingocanada.com</span>
        </div>
        <div class="info-item">
          <i class="el-icon-location"></i>
          <span>地址：9390 Woodbine Ave 2D8，Markham, ON L6C 0M5, Canada</span>
        </div>
      </section>

      <section class="contact-form">
        <h2>在线咨询</h2>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入您的电子邮箱"></el-input>
          </el-form-item>
          <el-form-item label="留言" prop="message">
            <el-input type="textarea" v-model="form.message" rows="4" placeholder="请输入您的咨询内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">提交</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </section>

      <section class="wechat-qr">
        <h2>微信咨询</h2>
        <div class="qr-code">
          <img src="@/assets/ewm.jpg" alt="微信二维码">
          <p>扫码添加微信咨询</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入咨询内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message.success('提交成功！我们会尽快与您联系。')
          this.resetForm(formName)
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.contact-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    text-align: center;
    margin-bottom: 40px;
    color: #333;
    font-size: 32px;
    font-weight: bold;
  }

  .contact-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    

    section {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      padding: 35px;
      border: 1px solid #f0f0f0;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
      }

      h2 {
        color: #e63946;
        margin-bottom: 25px;
        font-size: 26px;
        font-weight: bold;
        position: relative;
        padding-left: 15px;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 20px;
          background: #e63946;
          border-radius: 2px;
        }
      }
    }

    .contact-info {
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        color: #333;

        i {
          font-size: 22px;
          margin-right: 15px;
          color: #e63946;
        }

        span {
          line-height: 1.6;
        }
      }
    }

    .contact-form {
      .el-form {
        max-width: 500px;

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
          border-radius: 8px;
          &:focus {
            border-color: #e63946;
          }
        }

        /deep/ .el-button--primary {
          background-color: #e63946;
          border-color: #e63946;
          &:hover,
          &:focus {
            background-color: #d62f3c;
            border-color: #d62f3c;
          }
        }
      }

      .el-button {
        margin-right: 20px;
        border-radius: 8px;
        padding: 12px 25px;
        font-size: 16px;
      }
    }

    .wechat-qr {
      text-align: center;

      .qr-code {
        img {
          width: 200px;
          height: 200px;
          margin-bottom: 20px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        p {
          color: #333;
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .contact-page {
    padding: 20px;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    section {
      padding: 25px;

      h2 {
        font-size: 22px;
      }
    }

    .contact-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>